import React, { useState, useContext } from "react";
import { Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/auth";

function MenuBar() {
  const pathname = window.location.pathname;
  let path;
  if (pathname === "/board") {
    path = "Fangraphs";
  } else if (pathname === "/table") {
    path = "Prospect Compilation";
  } else if (pathname === "/addtowatchlist") {
    path = "Add To Watchlist";
  } else {
    path = pathname.substr(1);
  }
  const [activeItem, setActiveitem] = useState(path);
  const { user, logout } = useContext(AuthContext);
  const handleItemClick = (e, { name }) => setActiveitem(name);

  return (
    <div>
      {user && (
        <Menu stackable inverted style={{ paddingBottom: "4px" }}>
          <Menu.Item
            name="home"
            active={activeItem === "home"}
            onClick={handleItemClick}
            as={Link}
            to="/home"
          />
          <Menu.Item
            name="Fangraphs"
            active={activeItem === "Fangraphs"}
            onClick={handleItemClick}
            as={Link}
            to="/board"
            color={"green"}
          />
          <Menu.Item
            name="Prospect Compilation"
            active={activeItem === "Prospect Compilation"}
            onClick={handleItemClick}
            as={Link}
            to="/table"
            color={"blue"}
          />
          <Menu.Item
            name="myTeam"
            active={activeItem === "myTeam"}
            onClick={handleItemClick}
            as={Link}
            to="/myTeam"
            color={"violet"}
          />
          <Menu.Item
            name="farmSystem"
            active={activeItem === "farmSystem"}
            onClick={handleItemClick}
            as={Link}
            to="/farmSystem"
            color={"teal"}
          />
          <Menu.Item
            name="watchlist"
            active={activeItem === "watchlist"}
            onClick={handleItemClick}
            as={Link}
            to="/watchlist"
            color={"orange"}
          />
          <Menu.Menu position="right" className="logoutbutton">
            <Menu.Item name="logout" to="/" onClick={logout} />
          </Menu.Menu>
        </Menu>
      )}
      {!user && (
        <Menu inverted>
          <Menu.Item
            name="login"
            active={activeItem === "login"}
            onClick={handleItemClick}
            as={Link}
            to="/login"
            color={"blue"}
          />
          <Menu.Item
            name="register"
            active={activeItem === "register"}
            onClick={handleItemClick}
            as={Link}
            to="/register"
            color={"green"}
          />
        </Menu>
      )}
    </div>
  );
}

export default MenuBar;
